import React, {useState} from 'react'
import {ClickAwayListener, IconButton} from '@material-ui/core'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import {connect} from 'react-redux'
import {alertActions} from '../../../../actions'

function OccurrenceMoreMenu(props) {
    const {
        copysuccess,
        copyfailure,
        handleUpload,
        handleCloneOccurrence,
        row,
    } = props
    const [anchorEl, setAnchorEl] = useState(null)

    const virtualeventlink =
        process.env.REACT_APP_VIRTUAL_EVENT_APP_URL +
        `/${row.deptId}/${row.eventId}/${row.occurId}`

    const handleClick = event => {
        event.stopPropagation()
        setAnchorEl(event.currentTarget)
    }

    const handleClose = event => {
        event.stopPropagation()
        setAnchorEl(null)
    }

    const copyToClipboard = str => {
        navigator.clipboard.writeText(str).then(
            function() {
                copysuccess(`Copied ${str} to clipboard`)
            },
            function() {
                copyfailure(`Failed to copy ${str} to clipboard`)
            }
        )
    }

    const isVirtual = ['H', 'O'].indexOf(row.occurKind) >= 0 ? true : false

    return (
        <>
            <ClickAwayListener onClickAway={handleClose}>
                <div>
                    <IconButton
                        aria-controls="more-actions-menu"
                        aria-haspopup="true"
                        onClick={handleClick}
                    >
                        <MoreVertIcon
                            style={{
                                color: '#098447',
                            }}
                        />
                    </IconButton>

                    <Menu
                        id="more-actions-menu"
                        anchorEl={anchorEl}
                        keepMounted
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                    >
                        <MenuItem
                            onClick={event => {
                                event.stopPropagation()
                                handleCloneOccurrence(row)
                            }}
                        >
                            Clone Event
                        </MenuItem>
                        <MenuItem
                            onClick={event => {
                                event.stopPropagation()
                                handleUpload(row)
                            }}
                        >
                            Batch Upload Swipes
                        </MenuItem>
                        {isVirtual ? (
                            <MenuItem
                                onClick={event => {
                                    event.stopPropagation()
                                    copyToClipboard(virtualeventlink)
                                }}
                            >
                                Copy Virtual Event Link
                            </MenuItem>
                        ) : null}
                    </Menu>
                </div>
            </ClickAwayListener>
        </>
    )
}

const mapDispatchToProps = {
    copysuccess: message => alertActions.success(message),
    copyfailure: message => alertActions.error(message),
}

export default connect(null, mapDispatchToProps)(OccurrenceMoreMenu)
